import {
  equals,
  filter,
  find,
  has,
  ifElse,
  includes,
  indexOf,
  isNil,
  keys,
  length,
  lt,
  mergeAll,
  not,
  pipe,
  sort,
} from 'ramda';
import { LocalStorage } from '../../helpers/localStorage';
import { Game } from '../../api/games';

export function isFavoriteGame(
  currencies: Game['real'],
  favoriteGames: number[]
) {
  return (
    Object.values(currencies)
      .map(({ id }) => id)
      .findIndex((c) => favoriteGames.includes(c)) !== -1
  );
}

const sortByFavoriteGamesArray = (favoriteGames: number[]) => (
  gameA: Game,
  gameB: Game
) =>
  favoriteGames.findIndex((id) =>
    Object.values(gameB.real)
      .map(({ id }) => id)
      .includes(id)
  ) -
  favoriteGames.findIndex((id) =>
    Object.values(gameA.real)
      .map(({ id }) => id)
      .includes(id)
  );

export function isFavoriteGames(games: Game[], favoriteGames: number[]) {
  return games
    .filter(({ real }) => isFavoriteGame(real, favoriteGames))
    .sort(sortByFavoriteGamesArray(favoriteGames));
}
const RECENT_GAMES_STORAGE_NAME = 'recent-games';
const MAX_ITEMS_RECENT_GAMES = 30;
export interface GameInfoStorage {
  [id: string]: string;
}

export const recentGamesStorage = new LocalStorage<GameInfoStorage[], []>(
  RECENT_GAMES_STORAGE_NAME,
  []
);

export function getRecentGames(games: Game[]) {
  const recentGamesStorageArr = recentGamesStorage.get();
  const recentGamesIds = keys(mergeAll(recentGamesStorageArr)) as string[];

  const gamesArray = filter(({ id }) => !!includes(id, recentGamesIds), games);

  const sortGames = (game1: Game, game2: Game) =>
    indexOf(game2.id)(recentGamesIds) - indexOf(game1.id)(recentGamesIds);

  return sort(sortGames, gamesArray);
}

export function addGameToStorage(
  { id, title }: Game,
  storageName: string,
  maxStorageLength: number
) {
  const gamesStorage = new LocalStorage<GameInfoStorage[], []>(storageName, []);
  const storageArr = gamesStorage.get();
  const currentGameInStorage = find(has(id))(storageArr);

  const replaceFirstGame = () => {
    storageArr.shift();
    gamesStorage.replace([...storageArr, { [id]: title }]);
  };

  const changeGamePosition = () => {
    const filteredArr = filter((game) => {
      return not(equals(keys(game)[0], keys(currentGameInStorage)[0]));
    }, storageArr);
    gamesStorage.replace([...filteredArr, { [id]: title }]);
  };

  const addNextGameToList = () => gamesStorage.push([{ [id]: title }]);

  return ifElse(
    isNil,
    ifElse(
      pipe(() => length(storageArr), lt(maxStorageLength)),
      replaceFirstGame,
      addNextGameToList
    ),
    changeGamePosition
  )(currentGameInStorage);
}

export const addGameToRecentViewedStorage = (game: Game) =>
  addGameToStorage(game, RECENT_GAMES_STORAGE_NAME, MAX_ITEMS_RECENT_GAMES);
